import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="C Programming" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                C Language
              </h1>
              <p className="text-secondary" id="Language_Para">
                What is C language used for? C programming language is a
                machine-independent programming language that is mainly used to
                create many types of applications and operating systems such as
                Windows, and other complicated programs such as the Oracle
                database, Git, Python interpreter, and games and is considered a
                programming foundation.
                <br />
                10 Most Important Features of C Language You Must be Aware Of By
                Ravikiran A S Last updated on Feb 7, 2023164186 10 Features of C
                Language You Must be Aware Of Table of Contents.
                <br />
                C programming is a general-purpose, procedural computer
                programming language originally developed at AT&T Bell Labs by
                Dennis Ritchie in the early 1970s. A successor of the B
                programming language, it was developed to overcome the
                challenges of BASIC, B, and BPCL programming languages. It had
                both high-level functionality and detailed features required to
                program an operating system. During the 1980s, C programming
                gained popularity for creating mainframes, microcomputers, and
                minicomputers and has become one of the most widely used
                programming languages. <br />
                What makes the C language so popular? Why are companies keen on
                hiring C professionals even today? The most basic and
                straightforward answer would be its features make it a unique
                and special language, thereby still holding its relevance and
                popularity.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
